export const initShareHomepageSwapText = () => {
  const landingpage = document.querySelector(".landingpage") as HTMLDivElement;

  if (!landingpage) {
    return;
  }

  const payoff = landingpage.querySelector(".payoff") as HTMLParagraphElement;

  if (!payoff) {
    return;
  }

  const swapText = payoff.querySelector(".swap-text") as HTMLSpanElement;
  const swapWords: NodeListOf<HTMLElement> = payoff.querySelectorAll(".swap-text .word");

  if (!swapText || !swapWords) {
    return;
  }

  function handlePayoffHeight() {
    /**
     * START Set swap-text height to the height of displaying the longest word
     * Otherwise the height of the payoff may increase and decrease every time the swapWord changes, which causes the page to flip
     */
    let maxWidth = 0;
    let maxWidthWord: HTMLElement | null = null;

    payoff.style.minHeight = "";

    // Hide all words
    swapWords.forEach((swapWord) => {
      swapWord.classList.add("d-none");
    });

    // Check which swapWord is the longest
    swapWords.forEach((swapWord: HTMLElement) => {
      swapWord.classList.remove("d-none");

      if (swapWord.offsetWidth > maxWidth) {
        maxWidth = swapWord.offsetWidth;
        maxWidthWord = swapWord;
      }

      swapWord.classList.add("d-none");
    });

    if (maxWidthWord) {
      // @ts-expect-error: It is assigned
      maxWidthWord.classList.remove("d-none");
    }

    payoff.style.minHeight = `${payoff.clientHeight}px`;

    // If it's the last word, set fixed width to force it always on the next line if 1 of the words is
    if (checkSwapTextPositionIsLastWord()) {
      swapText.style.width = `${maxWidth + 1}px`;
    }

    // Reset: show first swapWord
    swapWords.forEach((swapWord) => {
      swapWord.classList.add("d-none");
    });
    swapWords[0].classList.remove("d-none");
  }

  function checkSwapTextPositionIsLastWord() {
    // Check if there's any non-whitespace content after the swap-text
    let nextNode = swapText.nextSibling;

    while (nextNode) {
      // If we find any text content or element after swap-text, it's not the last word
      if (
        (nextNode.nodeType === Node.TEXT_NODE && nextNode.textContent?.trim() !== "") ||
        nextNode.nodeType === Node.ELEMENT_NODE
      ) {
        return false;
      }
      nextNode = nextNode.nextSibling;
    }

    // If we didn't find any meaningful content after swap-text, it is the last word
    return true;
  }

  const body = document.querySelector("html") as HTMLElement;

  // Set payoff height
  if (window.ResizeObserver) {
    // Check if browser supports ResizeObserver
    const observer = new ResizeObserver(handlePayoffHeight);

    observer.observe(body);
  }

  // Set payoff height again after all CSS has loaded
  window.addEventListener("load", () => {
    handlePayoffHeight();
  });

  /**
   * END Set swap-text height to the height of displaying the longest word
   */

  let counter = 0;
  setInterval(changeWord, 1000);

  function changeWord() {
    swapWords.forEach((swapWord) => {
      swapWord.classList.remove("d-inline-block");
      swapWord.classList.add("d-none");
    });

    swapWords[counter].classList.remove("d-none");
    swapWords[counter].classList.add("d-inline-block");

    counter++;
    if (counter >= swapWords.length) {
      counter = 0;
    }
  }
};
